function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M6.66898 12.8801C6.37918 12.8801 6.14368 12.6452 6.14368 12.3551C6.14368 12.0662 6.37948 11.8307 6.66898 11.8307C6.95788 11.8307 7.19218 12.0662 7.19218 12.3551C7.19248 12.6452 6.95818 12.8801 6.66898 12.8801Z",
  fill: "#1442A8"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M4.72528 11.468C4.43608 11.468 4.20148 11.2337 4.20148 10.9448C4.20148 10.6547 4.43578 10.4192 4.72528 10.4192C5.01388 10.4192 5.24938 10.6547 5.24938 10.9448C5.24938 11.2337 5.01388 11.468 4.72528 11.468Z",
  fill: "#1442A8"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M0.810884 11.3813C0.523184 11.3813 0.287384 11.147 0.287384 10.856C0.287384 10.5671 0.523184 10.331 0.810884 10.331C1.10368 10.331 1.33828 10.5674 1.33828 10.856C1.33828 11.147 1.10368 11.3813 0.810884 11.3813Z",
  fill: "#1442A8"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M4.5483 13.6217C4.2588 13.6217 4.0242 13.3859 4.0242 13.0967C4.0242 12.8057 4.2588 12.5717 4.5483 12.5717C4.839 12.5717 5.0748 12.806 5.0748 13.0967C5.0748 13.3859 4.8387 13.6217 4.5483 13.6217Z",
  fill: "#1442A8"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M2.78549 12.7127C2.49629 12.7127 2.25989 12.4781 2.25989 12.1883C2.25989 11.8985 2.49659 11.6648 2.78549 11.6648C3.07439 11.6648 3.31019 11.8982 3.31019 12.1883C3.31019 12.4784 3.07469 12.7127 2.78549 12.7127Z",
  fill: "#1442A8"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M11.5266 4.907C10.2006 4.6415 9.33779 3.3359 9.60569 1.9946C9.87509 0.650904 11.1726 -0.218196 12.4998 0.047904C13.8294 0.314604 14.688 1.6145 14.4192 2.9585C14.1507 4.2986 12.8562 5.1728 11.5266 4.907Z",
  fill: "#1442A8"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M2.4933 19.2287C3.8325 19.2251 4.92 18.1379 4.9269 16.7957C4.92 15.4496 3.8328 14.3624 2.4933 14.36C1.1463 14.3624 0.0590979 15.4496 0.0614979 16.7957C0.0587979 18.1379 1.146 19.2251 2.4933 19.2287Z",
  fill: "#1442A8"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M10.3539 13.3415C10.6572 13.3415 10.9971 13.2137 11.3094 12.848L14.7294 8.27841L18.9174 12.2603V14.0582L22.7259 14.6708V9.60321C22.7268 9.29961 22.6224 9.04401 22.4124 8.83431L17.3445 3.80061C17.004 3.50721 16.6509 3.26451 16.1847 3.24531C15.7596 3.22761 15.1341 3.50091 14.7417 4.04781C14.7096 4.07361 9.5118 11.2625 9.5118 11.2625C9.1368 11.7512 9.0516 12.5462 9.4851 12.974C9.7278 13.2134 10.0383 13.3415 10.3539 13.3415Z",
  fill: "#1442A8"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M7.8726 20.0138V19.3085L28.2771 19.2683C28.9845 19.2695 29.559 18.6218 29.5614 17.8208C29.5614 17.021 28.7718 16.4492 28.2801 16.3706C28.2801 16.3706 16.5912 14.1956 13.4073 13.8737C12.9582 13.8281 9.0378 13.6214 6.8991 14.8739C6.1335 15.3224 5.4615 16.1513 5.3802 17.0603C5.3724 17.1464 5.3715 17.2331 5.3739 17.3201V20.0138H0.206696V24.7232H1.4094V21.2168H5.3736V27.2927C5.3736 27.9827 5.9331 28.5422 6.6231 28.5422C7.3131 28.5422 7.8726 27.9827 7.8726 27.2927V21.2168H28.5087V24.7232H29.7117V20.0138H7.8726Z",
  fill: "#1442A8"
});

var SvgMassage = function SvgMassage(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 29,
    viewBox: "0 0 30 29",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMassage, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/massage.beb80f02.svg";
export { ForwardRef as ReactComponent };